<div class='header'>
  <div class="title" (click)="home()">
    <img src="assets/logos/logo_with_text.png" />
  </div>
  <div class="menu-buttons">
    @if (userIsLoggedIn) {
      <ng-container *ngTemplateOutlet="loginView"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="noLoginView"></ng-container>
    }
  </div>
  <ng-container *ngTemplateOutlet="loginButton"></ng-container>

  <div class="side-menu-button">
      <p-button icon="pi fi fi-rr-sidebar" outlined (click)="sidebarVisible = !sidebarVisible"></p-button>
  </div>
</div>
<!--@if (couponCodeVisible) {-->
<!--  <div class="message">-->
<!--  Use code <b>GraceUponGrace</b> for <b>15%</b> Easter savings! Offer ends in {{timeLeft$ | async}}.-->
<!--  </div>-->
<!--}-->
<!--PAGE END-->

<p-sidebar [(visible)]="sidebarVisible" position="left">
  <ng-template pTemplate="header">
    <h1>RoRender</h1>
  </ng-template>
  <div class="sidebar-contents">
    @if (userIsLoggedIn) {
      <ng-container *ngTemplateOutlet="loginView"></ng-container>
    }
    @else {
      <ng-container *ngTemplateOutlet="noLoginView"></ng-container>
    }
    <ng-container *ngTemplateOutlet="loginButton"></ng-container>
  </div>
</p-sidebar>

<ng-template #noLoginView>
  <p-button label="Stats" icon="pi fi fi-rr-chart-histogram" text severity="secondary" (click)="navigateAndScrollTo('stats')"></p-button>
  <p-button label="Features" icon="pi fi fi-rr-features" text severity="secondary" (click)="navigateAndScrollTo('features')"></p-button>
  <p-button label="Reviews" icon="pi fi fi-rr-satisfaction-bar" text severity="secondary" (click)="navigateAndScrollTo('reviews')"></p-button>
  <p-button label="Pricing" icon="pi fi fi-rr-brand" text severity="secondary" (click)="navigateAndScrollTo('pricing')"></p-button>
  <p-button label="FAQ" icon="pi fi fi-rr-comments-question" text severity="secondary" (click)="navigateAndScrollTo('faq')"></p-button>
</ng-template>

<ng-template #loginView>
  <p-button label="My Renders" icon="pi pi-list" routerLink="my-renders" text severity="secondary"></p-button>
  @if (isInGroup$ | async) {
    <p-button label="Enterprise" icon="pi fi fi-rr-building" routerLink="enterprise" text severity="secondary"></p-button>
  }
  <p-button label="Store" icon="pi fi fi-rr-marketplace-store" routerLink="market" text severity="secondary"></p-button>
  <p-button label="Docs" icon="pi fi fi-rr-document-signed" routerLink="docs/quick-start" text severity="secondary"></p-button>
</ng-template >

<ng-template #loginButton>
  <div class="login-container">
    @if(userIsLoggedIn) {
      @if(activeSub$ | async) {
        <p-button
          (click)="redirectToPortal()"
          [loading]="awaitStripePortal"
          label="Manage Sub"
          icon="pi fi fi-rr-daily-calendar"
          severity="help"
          size="small"
          rounded
          outlined
        />
      }
      @else {
        @if ((credits$ | async) !== null) {
            <p-button
              routerLink="market"
              [label]="((credits$ | async) || 0).toString() + ' Credits'"
              icon="pi fi fi-rr-coins"
              severity="success"
              size="small"
              rounded
              outlined
            />
        }
      }
    }
    <p-button [label]="userIsLoggedIn ? 'Logout' : 'Login/Register'"  icon="pi fi fi-rr-user" outlined (click)="logButton()"></p-button>
  </div>
</ng-template >

